import { Badge, Button } from '@e2n/ui/v2';
import { BerufeFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/BerufeFilter';
import { LehrjahrFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/LehrjahrFilter';
import { StatusFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/StatusFilter';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StandorteFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/StandorteFilter.tsx';
import { SortierungButton } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SortierungButton.tsx';

export function Header() {
  const [showUebersichtFilterOptions, setShowUebersichtFilterOptions] =
    useState(false);
  const { store } = useRotationsplanFeatureContext();
  const { t } = useTranslation();

  const {
    ui: {
      uebersicht: { filter },
    },
  } = store;

  let selectedFilterCount = 0;
  Object.values(filter).forEach((filter) => {
    if (filter.length > 0) {
      selectedFilterCount += 1;
    }
  });

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-wrap items-center gap-2">
        <Button
          className="gap-2"
          variant="ghost"
          onClick={() => setShowUebersichtFilterOptions((prev) => !prev)}>
          <FontAwesomeIcon className="size-4" icon={faFilter} />
          {t('domain.mitarbeiter.rotationsplan.filter.label')}
          <Badge className="bg-neutrals-v2-300 text-labels-primary">
            {selectedFilterCount}
          </Badge>
        </Button>
        <SortierungButton view="uebersicht" />
      </div>
      {showUebersichtFilterOptions && (
        <div className="w-full overflow-auto">
          <div className="flex items-center gap-2">
            <BerufeFilter view="uebersicht" />
            <LehrjahrFilter view="uebersicht" />
            <StatusFilter />
            <StandorteFilter view="uebersicht" />
          </div>
        </div>
      )}
    </div>
  );
}
